export default "__VITE_ASSET__74c007cf__"